import * as React from 'react'

import './style.css'
import { ReactChildren } from '../../types/react'

type RGBA = [number, number, number, number]
type RGBAToStringType = (color: RGBA) => string

const rgbaToString: RGBAToStringType = ([r, g, b, a]) =>
  `rgba(${r}, ${g}, ${b}, ${a})`

export type Props = {
  active: boolean
  children: ReactChildren
  backgroundColor: RGBA
}

const Overlay = (props: Props) => {
  if (props.active) {
    return (
      <div className="overlay-background">
        <div
          className="progress stripes animated reverse slower"
          style={{
            backgroundColor: rgbaToString(props.backgroundColor),
          }}
        />
        {props.children}
      </div>
    )
  }

  return (
    <div className="overlay-background">
      <div />
      {props.children}
    </div>
  )
}

export default Overlay
